import { Television } from "@phosphor-icons/react";
import { useTvMode } from "@/context/TvModeContext";

export const TvModeToggle = ({ variant = "nav" }) => {
  const { tvMode, toggleTvMode } = useTvMode();

  const base =
    "flex items-center gap-2 border px-3.5 py-2.5 font-mono text-[11px] uppercase tracking-[0.15em] transition-colors duration-300";
  const on = "border-amber bg-amber/10 text-amber";
  const off = "border-white/10 text-white/70 hover:border-amber hover:text-amber";

  return (
    <button
      data-testid="tv-mode-toggle"
      onClick={toggleTvMode}
      aria-pressed={tvMode}
      title={tvMode ? "Exit TV Mode" : "Enter TV Mode (10-foot UI)"}
      className={`${base} ${tvMode ? on : off}`}
    >
      <Television size={16} weight={tvMode ? "fill" : "duotone"} />
      <span className={variant === "nav" ? "rv-hdr-label hidden min-[1700px]:inline whitespace-nowrap" : ""}>
        {tvMode ? "TV Mode On" : "TV Mode"}
      </span>
    </button>
  );
};
